const centerByCountry = (country: string) => {
    switch (country) {
    case 'MX':
    case 'México':
        return {
            lng: -99.133209,
            lat: 19.432607,
        };
    case 'CO':
    case 'Colombia':
        return {
            lng: -74.072092,
            lat: 4.60971,
        };
    case 'EC':
    case 'Ecuador':
        return {
            lng: -79.8882522301666,
            lat: -2.09757780361609,
        };
    case 'DO':
    case 'República Dominicana':
        return {
            lng: -70.669291,
            lat: 18.466338,
        };
    case 'AR':
    case 'Argentina':
        return {
            lng: -64.181053,
            lat: -34.603722,
        };
    case 'CL':
    case 'Chile':
        return {
            lng: -70.669291,
            lat: 18.466338,
        };
    default:
        return {
            lng: -79.8882522301666,
            lat: -2.09757780361609,
        };
    }
};

export {
    centerByCountry,
};
